// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2MY1l","image":"Header_image__3N3FA","name":"Header_name__3th2w","info":"Header_info__3xtyL","infoRow":"Header_infoRow__14lC9"};